import { render, staticRenderFns } from "./IntegrationsCard.vue?vue&type=template&id=a2b2d67a&scoped=true"
import script from "./IntegrationsCard.vue?vue&type=script&lang=js"
export * from "./IntegrationsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b2d67a",
  null
  
)

export default component.exports